export default __webpack_public_path__ + "static/media/ArmazemAlfandega4.abd55be9.jpg";